import { render, staticRenderFns } from "./AppPointsContainer.vue?vue&type=template&id=1675221b"
import script from "./AppPointsContainer.vue?vue&type=script&lang=js"
export * from "./AppPointsContainer.vue?vue&type=script&lang=js"
import style0 from "./AppPointsContainer.vue?vue&type=style&index=0&id=1675221b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports